module.exports = __webpack_public_path__ + "static/media/tech-structured-2.7d0e2c2d.png";